import axiosClient from "utils/api";
const URI = "/admin/helpAndFeedback";

export const getHelpAndFeedback = async (payload) => {
  const URL = `${URI}`;
  try {
    const response = await axiosClient().request({
      url: URL,
      method: "get",
      params: payload,
    });
    return response.data;
  } catch (error) {
    console.error("Error occurred Get All Help And Feedback:", error);
    throw error;
  }
};

export const deleteHelpAndFeedback = async (payload) => {
  const URL = `${URI}/${payload.id}`;
  try {
    const response = await axiosClient().request({
      url: URL,
      method: "delete",
    });
    return response.data;
  } catch (error) {
    console.error("Error occurred Delete Help And Feedback:", error);
    throw error;
  }
};

export const updateHelpAndFeedback = async (payload) => {
  let { id, ...rest } = payload;
  const URL = `${URI}/${id}`;
  try {
    const response = await axiosClient().request({
      url: URL,
      method: "put",
      data: rest,
    });
    return response.data;
  } catch (error) {
    console.error("Error occurred Update Help And Feedback:", error);
    throw error;
  }
};

export const addHelpAndFeedback = async (payload) => {
  const URL = `${URI}`;
  try {
    const response = await axiosClient().request({
      url: URL,
      method: "post",
      data: payload,
    });
    return response.data;
  } catch (error) {
    console.error("Error occurred Add Help And Feedback:", error);
    throw error;
  }
};
